import { render, staticRenderFns } from "./Supercampaigns.vue?vue&type=template&id=4bb6f3a2&"
import script from "./Supercampaigns.vue?vue&type=script&lang=js&"
export * from "./Supercampaigns.vue?vue&type=script&lang=js&"
import style0 from "./Supercampaigns.vue?vue&type=style&index=0&id=4bb6f3a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports